import { log2 } from "../../utils/log2";
import { MODULE_API } from "../../api/module";

const log = log2("store.module");

const module = {
    namespaced: true,
    state: {
        modules: [],
        currentModule: null,
        loading: false,
    },
    getters: {
        getModules: (state) => state.modules,
        getCurrentModule: (state) => state.currentModule,
        contactRelatedListModules: (state) =>
            state.modules
                .filter((module) => module.type === "relation")
                .filter((module) => !!module.relation?.standartToTable?.from)
                .filter((module) => module.relation.type === "standart-to-table")
                .filter((module) => module.relation.standartToTable.from.module === "contact"),

        getTableRelatedModules: (state) => (tableId) =>
            state.modules
                .filter((module) => module.type === "relation")
                .filter((module) => !!module.relation?.tableToTable?.from)
                .filter(
                    (module) =>
                        module.relation.tableToTable.from.table === tableId &&
                        ["table-to-table", "table-to-standart"].includes(module.relation.type)
                ),
    },
    mutations: {
        SET_MODULES(state, modules) {
            log("SET_MODULES", modules);
            state.modules = modules;
        },
        SET_CURRENT_MODULE(state, module) {
            state.currentModule = module;
        },
        SET_LOADING(state, isLoading) {
            log("SET_LOADING", isLoading);
            state.loading = isLoading;
        },
    },
    actions: {
        async syncModules({ commit }) {
            try {
                commit("SET_LOADING", true);
                const data = await MODULE_API.getModules();
                log("syncModules", data);
                if (Array.isArray(data)) {
                    commit("SET_MODULES", data);
                }
                commit("SET_LOADING", false);
            } catch (e) {
                log.error(e);
                commit("SET_LOADING", false);
            }
        },
        async getModuleById({ commit }, moduleId) {
            try {
                const data = await MODULE_API.getModuleById(moduleId);
                log("getModuleById", data);
                commit("SET_CURRENT_MODULE", data);
                return data;
            } catch (e) {
                log.error(e);
                return null;
            }
        },
        async createModule({ dispatch }, moduleData) {
            try {
                await MODULE_API.createModule(moduleData);
                dispatch("syncModules");
                return true;
            } catch (e) {
                log.error(e);
                throw e;
            }
        },
        async updateModule({ dispatch }, { moduleName, updatingFields }) {
            try {
                await MODULE_API.updateModule(moduleName, updatingFields);
                dispatch("syncModules");
            } catch (e) {
                log.error(e);
            }
        },
        async deleteModule({ dispatch }, moduleId) {
            try {
                await MODULE_API.deleteModule(moduleId);
                dispatch("syncModules");
            } catch (e) {
                log.error(e);
            }
        },
    },
};

export default module;
